import UserApi from '@/frontend/api/user';
import { mapGetters } from 'vuex';
import { ElLoading } from 'element-plus';
export default {
  name: "MailVerificationPage",

  data() {
    return {
      time: 0,
      defaultTime: 59
    };
  },

  computed: { ...mapGetters(['email']),

    formattedEmail() {
      let name = this.email.split('@')[0],
          index,
          result = [];
      if (name.length >= 9) index = this.email.lastIndexOf('@') - 4;else if (name.length >= 8) index = this.email.lastIndexOf('@') - 3;else if (name.length >= 7) index = this.email.lastIndexOf('@') - 2;else if (name.length >= 5) index = this.email.lastIndexOf('@') - 1;else index = this.email.lastIndexOf('@');
      result.push(name.slice(0, 2));
      result = result.concat(Array(index - 2).fill('*'));
      result.push(this.email.slice(index));
      return result.join('');
    }

  },
  methods: {
    tickTime() {
      setTimeout(() => {
        this.time -= 1;
        if (this.time > 0) this.tickTime();
      }, 1000);
    },

    resend() {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      UserApi.resend({
        email: this.email
      }).then(() => {
        this.time = this.defaultTime;
        this.tickTime();
      }).finally(() => loader.close());
    }

  },

  created() {
    this.time = this.defaultTime;
  },

  mounted() {
    this.tickTime();
  }

};